module.exports = __webpack_public_path__ + "img/NEW-KoPo-Logo.913f2cf1.svg";